import { useSelector } from "react-redux";
import logo from "../../assets/images/logo.png";

export default function Navbar({ setisProductPage }) {
  const cartItems = useSelector((state) => state.cart);

  const totalCartItems = cartItems.reduce(
    (total, item) => total + item.cartQuantity,
    0
  );

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a href="index.html">
          <img src={logo} alt="LWS" className="max-w-[140px]" />
        </a>
        <div className="flex gap-4">
          <a
            href="#home"
            className="navHome"
            id="lws-home"
            onClick={() => setisProductPage(true)}
          >
            {" "}
            Home{" "}
          </a>
          <a
            href="#cart"
            onClick={() => setisProductPage(false)}
            className="navCart"
            id="lws-cart"
          >
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping" />
            <span id="lws-totalCart">{totalCartItems}</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
